<template>
    <profile style="width: 762px; margin: auto" :is-identified="isIdentified" />
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import Profile from './Profile';

export default {
    name: 'profile-container',
    components: {
        Profile,
    },
    methods: {
        ...mapActions('contract', ['fetchContractLink']),
    },
    watch: {
        // isFilled(newIsFilled) {
        //     if (!this.main && !this.contractStatusIsSigned && newIsFilled) {
        //         this.fetchContractLink();
        //     }
        // }
    },
    computed: {
        ...mapGetters('contractStatus', ['isFetched']),
        ...mapState('contract', ['main']),
        ...mapGetters('profile', ['isIdentified'])
    }
}
</script>


// WEBPACK FOOTER //
// ProfileContainer.vue?7a894cfc